import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../Auth/AuthContext";
import { Card, Rate, Col, Carousel, message, Modal, Button, notification, Tabs, Pagination, Badge, Row, TabsProps, Form, Input } from "antd";
import { BiCheckCircle, BiDirections, BiPhone, BiPhoneCall, BiShield } from "react-icons/bi";
import { FaEdit, FaHeart, FaRegHeart, FaRegShareSquare, FaRegThumbsUp, FaPhotoVideo, FaStar, FaWhatsapp, FaShare } from "react-icons/fa";
import { CalculatorOutlined, ClockCircleFilled, CopyFilled, EnvironmentOutlined } from "@ant-design/icons";
import { useParams, useNavigate,useLocation, Link } from "react-router-dom";
import { getBusinessDetail, addReview } from "../../../utils/API";
import Edit from "../../backend/Package/Edit";
import { AiOutlineClose } from 'react-icons/ai';
import TextArea from "antd/es/input/TextArea";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import shieldImage from "../../../assets/frontendassets/Vector (1).png"
import verifiedlogo from "../../../assets/frontendassets/Verification Icons/1.png";
import dummyuser from "../../../assets/frontendassets/dummyuser.png";
import trustLogo from "../../../assets/frontendassets/Verification Icons/3.png";
import { PhoneIcon } from "@heroicons/react/24/outline";
import { BsFillPhoneFill } from "react-icons/bs";
import "./BusinessDetail.css"
const { TabPane } = Tabs;

interface BusinessHour {
  closeTime: string;
  openTime: string;
  name: string;
  selected: boolean;
  from: string;
  to: string;
  _id: string;
}

interface Review {
  author: string;
  image: string;
  rating: number;
  comment: string;
  date: string;
  userId: any;
}

interface BusinessDetail {
  _id: string;
  pincode: string;
  state: string;
  streetName: string;
  buildingName: string;
  businessHours: BusinessHour[];
  businessName: string;
  mobileNumber: string | string[];
  whatsappNumber : any;
  name: string;
  email: string;
  city : any;
  galleryImage: string[];
  location: string;
  reviews?: Review[];
  categoryId: any;
  rating?: number;
  averageRating?: any;
  reviewsCount?: number;
  suggestions?: number;
  isVerified : any;
  isTrusted : any;
  createdAt ?: string;
  gstNo : any;
  gstinNo : any;
  userId?: string;
}

const BusinessDetail: React.FC = () => {
  const { authData } = useContext(AuthContext);
  const isLoggedIn = authData?.token;
  const userId = authData?.user?._id;
  const [businessDetail, setBusinessDetail] = useState<BusinessDetail | null>(null);
  const [isNumberVisible, setIsNumberVisible] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isRatingModalVisible , setIsRatingModalVisible] = useState<boolean>(false);
  const [isRatingLoading , setIsRatingLoading] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [wishlist, setWishlist] = useState<any[]>([]);
  const { slug } = useParams<{ slug: string }>();
  const imageUrl = process.env.REACT_APP_IMAGE_URL + "/businesse/";
  const userImageUrl = process.env.REACT_APP_IMAGE_URL + "/users/";
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const [formVisible, setFormVisible] = useState(false);
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [error, setError] = useState(null);
  const [slidesToShow, setSlidesToShow] = useState(2);
  const businessId = businessDetail?._id;
  // const [showMore, setShowMore] = useState(false);
  // const toggleShowMore = () => setShowMore(!showMore);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10); // Reviews per page
  const [showMore, setShowMore] = useState<{ [key: number]: boolean }>({});
  const [activeKey, setActiveKey] = useState<string>("1");
   const [days, setDays] = useState([
      { name: "Mon", selected: false, openTime: "", closeTime: "" },
      { name: "Tue", selected: false, openTime: "", closeTime: "" },
      { name: "Wed", selected: false, openTime: "", closeTime: "" },
      { name: "Thu", selected: false, openTime: "", closeTime: "" },
      { name: "Fri", selected: false, openTime: "", closeTime: "" },
      { name: "Sat", selected: false, openTime: "", closeTime: "" },
      { name: "Sun", selected: false, openTime: "", closeTime: "" },
    ]);

  const handleTabChange = (key: string) => {
    setActiveKey(key);
  };

  
  const handleRatingClick = (index: number) => {
    setRating(index + 1); // Update the rating based on the clicked star index

  };


  const handleSubmit = async () => {
    if (!businessId && !userId) {
      message.error("You must be logged in to submit a review.");
      return;
    }

    if (!rating) {
      message.error("Please select a rating.");
      return;
    }

    if (!reviewText) {
      message.error("Please enter a review.");
      return
    }

    setIsRatingLoading(true); // Start loading

    try {
      const data = { userId, rating, reviewText };

      const response = await addReview(businessId, data);
      message.success("Review submitted successfully!");
      setRating(0);
      setReviewText("");
      setIsRatingModalVisible(false);

      handleGetBusinessDetail();
    } catch (err) {
      message.error("Something went wrong. Please try again.");
    } finally {
      setIsRatingLoading(false); // Stop loading
    }
  };


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1200) {
        setSlidesToShow(6);
      } else if (window.innerWidth > 768) {
        setSlidesToShow(4);
      } else if (window.innerWidth > 435) {
        setSlidesToShow(2);
      }
      else {
        setSlidesToShow(1);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleGetBusinessDetail = async () => {
    try {
      const response = await getBusinessDetail(slug);
      
      setBusinessDetail(response[0]);
    } catch (error) {
      message.error("Network error. Please try again.");
    }
  };


  useEffect(() => {

    if (slug) {
      handleGetBusinessDetail();
    }
  }, [slug]);

  useEffect(() => {
    const savedWishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    setWishlist(savedWishlist);
  }, []);

  useEffect(() => {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  useEffect(() => {
    if (businessDetail) {
      setIsClicked(isInWishlist(businessDetail));
    }
  }, [businessDetail, wishlist]);

  if (!businessDetail) {
    return <div>Loading...</div>;
  }

  const {
    averageRating,
    businessHours,
    businessName,
    mobileNumber = [],
    whatsappNumber,
    email,
    galleryImage,
    location,
    reviews = [],
    // rating = 2,
    categoryId ,
    suggestions = 5,
    buildingName,
    streetName,
    state,
    isVerified,
    gstNo ,
    city,
    createdAt,
    isTrusted,
    pincode,
    gstinNo
  } = businessDetail;


  const mobileNumbersArray = Array.isArray(mobileNumber) ? mobileNumber : [mobileNumber];

  const formatTime = (time?: string): string => {
    if (!time) return '00.00'; // Return an empty string if time is undefined or empty
    const [hour, minute] = time.split(':').map(Number);
    const period = hour >= 12 ? 'PM' : 'AM';
    const adjustedHour = hour % 12 || 12; // Convert '00' to '12' for 12-hour format
    return `${adjustedHour}:${String(minute).padStart(2, '0')} ${period}`;
  };
  


  const formatBusinessHours = (hours: BusinessHour[]): JSX.Element[] => {
    return hours.map(hour => (
      <div key={hour._id}>
        <p>
          {`${hour.name}: ${hour.selected ? `${formatTime(hour.openTime)} - ${formatTime(hour.closeTime)}` : 'Closed'}`}
        </p>
      </div>
    ));
  };  

  const isOwner = authData?.user?._id ? (authData.user._id === businessDetail.userId) : null;


  const handleToggleNumberVisibility = () => {
    setIsNumberVisible(!isNumberVisible);
  };



  const handleCopyToClipboard = async () => {
    const originalUrl = window.location.href;
    try {
      // Shorten the URL using an API
      const response = await fetch('https://api-ssl.bitly.com/v4/shorten', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_BITLY_ACCESS_TOKEN}`, // Replace with your Bitly token
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ long_url: originalUrl }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to shorten URL');
      }
  
      const data = await response.json();
      const shortUrl = data.link; // This is the shortened URL
  
      // Copy the shortened URL to the clipboard
      if (navigator.clipboard) {
        navigator.clipboard.writeText(shortUrl)
          .then(() => message.success("URL copied to clipboard!"))
          .catch(() => message.error("Failed to copy shortened URL."));
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = shortUrl;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          message.success("URL copied to clipboard!");
        } catch (err) {
          message.error("Failed to copy shortened URL.");
        }
        document.body.removeChild(textarea);
      }
    } catch (error) {
      console.error(error);
      message.error("Error shortening the URL.");
    }
  };
  

  const handleAddressToClipboard = () => {
    // Constructing the address from businessDetail
    const address = `${buildingName}, ${streetName}, ${state}, ${pincode}`;
  
    if (navigator.clipboard) {
      navigator.clipboard.writeText(address)
        .then(() => message.success("Address copied to clipboard!"))
        .catch(() => message.error("Failed to copy address."));
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = address;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        message.success("Address copied to clipboard!");
      } catch (err) {
        message.error("Failed to copy address.");
      }
      document.body.removeChild(textarea);
    }
  };
  

  const isInWishlist = (business: any) => {
    return wishlist.some((item: any) => item.slug === business.slug);
  };
  
  const handleAddToWishlist = (business: any) => {
    if (!isLoggedIn) {
      // Notify the user that they need to log in
      notification.warning({
        message: 'Login Required',
        description: 'You must be logged in to save this to your wishlist.',
        placement: 'topRight'
      });
      navigate("/login", { state: { from:currentLocation.pathname  } });
    return; // Exit the function if not logged in
  }
  
    if (isInWishlist(business)) {
      handleRemoveFromWishlist(business);
    } else {
      setWishlist((prevWishlist: any) => [...prevWishlist, business]);
      notification.success({
        message: 'Added to Wishlist',
        description: 'This business has been saved successfully!',
        placement: 'topRight'
      });
    }
  };
  
  const handleRemoveFromWishlist = (business: any) => {
    setWishlist((prevWishlist: any) =>
      prevWishlist.filter((item: any) => item.slug !== business.slug)
    );
  };
  

  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  const handleEditRedirect = () => {
    if (businessDetail?._id) {
      navigate(`/business/${businessDetail._id}/edit`);
    } else {
      message.error("Business details are not available. Please try again.");
    }
  };
  const handleEnquiryRedirect = () => {
    navigate("/contact-us");
  };
  const handleButtonClick = () => {
    if (businessDetail?._id) {
      // navigate(`/business/${businessDetail._id}/edit?step=4`);
      navigate(`/business/${businessDetail._id}/editimage`);
    } else {
      message.error("Business details are not available. Please try again.");
    }
  };

  const renderReviews = (filteredReviews: any[]) => {
    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };
  
    const toggleShowMore = (index: number) => {
      setShowMore((prevShowMore) => ({
        ...prevShowMore,
        [index]: !prevShowMore[index],
      }));
    };
  
    if (!filteredReviews || filteredReviews.length === 0) {
      return (
        <div className="text-center text-gray-500 mt-4">
          No Reviews Available
        </div>
      );
    }
  
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const currentReviews = filteredReviews.slice(startIndex, endIndex);
  
    return (
      <>
        <div className="max-h-80 w-[80%] overflow-y-auto">
          <ul>
            {currentReviews.map((review, index) => {
              const maxTextLength = 100; // Limit to 100 characters, adjust as needed
              const isShowMore = showMore[index] || false;
  
              return (
                <>
                  <Row className="p-2">
                    <Col xs={6} sm={4} md={6} lg={4} xl={2} xxl={2} className="pt-2">
                      <img
                        src={review.userId.image ? `${userImageUrl}${review.userId.image}` : dummyuser}

                        alt="User Profile"
                        className="w-12 h-12 rounded-full"
                      />
                    </Col>
                    <Col xs={18} sm={20} md={18} lg={20} xl={22} xxl={22}>
                      <div className="mb-3 bg-[#FDF1DD] p-2 border-2 border-gray-300 rounded-lg pb-2">
                        <strong>{review.userId.firstName}</strong> <br />
  
                        <div className="flex items-center">
                          {/* Display stars dynamically based on the rating */}
                          <div className="flex">
                            {[...Array(5)].map((_, i) => {
                              const fullStars = Math.floor(review.rating); // Full stars count
                              const halfStar = review.rating % 1 !== 0; // Check for half star
  
                              if (i < fullStars) {
                                return (
                                  <span key={i} className="text-xl text-yellow-500">
                                    ★
                                  </span>
                                );
                              } else if (i === fullStars && halfStar) {
                                return (
                                  <span key={i} className="text-xl text-yellow-500">
                                    <span
                                      className="half-star"
                                      style={{ width: "50%", overflow: "hidden" }}
                                    >
                                      ★
                                    </span>
                                    <span
                                      className="half-star"
                                      style={{ width: "50%", color: "gray" }}
                                    >
                                      ★
                                    </span>
                                  </span>
                                );
                              } else {
                                return (
                                  <span key={i} className="text-xl text-gray-300">
                                    ★
                                  </span>
                                );
                              }
                            })}
                          </div>
                        </div>
  
                        {/* Review text with Read More/Less functionality */}
                        <p className="text-sm mt-2">
                          {isShowMore || review.reviewText.length <= maxTextLength
                            ? review.reviewText
                            : `${review.reviewText.slice(0, maxTextLength)}...`}
                          {review.reviewText.length > maxTextLength && (
                            <button
                              onClick={() => toggleShowMore(index)}
                              className="ml-2 text-blue-500 underline"
                            >
                              {isShowMore ? "Read Less" : "Read More"}
                            </button>
                          )}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            })}
          </ul>
        </div>
  
        {/* Pagination Component */}
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={filteredReviews.length}
          onChange={handlePageChange}
          className="mt-4"
        />
      </>
    );
  };
  


  
  const calculateBusinessAge = (createdAt: any) => {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
    const diffYears = currentDate.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      currentDate.getMonth() - createdDate.getMonth() +
      diffYears * 12;
    const years = Math.floor(diffMonths / 12);
    const months = diffMonths % 12;
      return years > 0
        ? `${years} yrs${years > 1 ? "" : ""} ${months} mth${months > 1 ? "" : ""} in business`
        : `${months} mth ${months > 1 ? "" : ""} in business`;
    };

    const handleLogin = () => {
      message.error("Please login to write a review");
      navigate("/login");
    };


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <div
          className={`text-[22px] ${
            activeKey === "1" ? "text-[#F9B138]" : "text-black"
          }`}
        >
          Business Details
        </div>
      ),
      children: 
      <>
<Row >
  <Col xs={24} lg={15} className="p-2">
    <Card className="mx-auto bg-[#FFF8EC] border-1 border-gray-300 rounded-lg">
      <Row>
        <Col span={24} className="text-xl p-2 font-semibold">
          Business Stautory Details
        </Col>
        <Col xs={24} lg={16} className="p-2">
          <Row className="p-2">
            <Col xs={24} sm={12}>
              <p className="text-gray-500 text-[16px]">Legal Name</p>
              <p className="text-black font-[400] text-[20px]">{businessName ? businessName : ""}</p>
            </Col>
            <Col xs={24} sm={12}>
              <p className="text-gray-500 text-[16px]">Business Category</p>
              {/* <p className="text-gray-500 text-[16px]">{categoryId.name}</p> */}
              <p className="text-black font-[400] text-[20px]">
  {Array.isArray(categoryId) && categoryId[0]?.name ? categoryId[0].name : ""}
</p>

            </Col>
          </Row>
          <Col span={24} className="p-2">
            <p className="text-gray-500 text-[16px]">Address</p>
            <p className="text-black font-[400] text-[20px]">
              {buildingName ? buildingName : ""}, {streetName ? streetName : ""}, {state ? state : ""}, {pincode ? pincode : ""}
            </p>
          </Col>
        </Col>
        <Col xs={24} lg={8} className="flex justify-center items-center">
          <img src={shieldImage} className="max-w-full" alt="Shield" />
        </Col>
      </Row>
    </Card>
    <Row align="middle" className="pt-2">
      <Col span={4} className="pt-4">
        <hr className="border-t-4 border-black border-2 h-2 mx-auto" />
      </Col>
      <Col span={20} className="pt-4 text-[20px] font-semibold">
        Any Query
      </Col>
      <Col span={24} className="pt-4">
        <Form>
          <Form.Item
            name="message"
            rules={[{ required: true, message: "Please enter your message" }]}
            className="relative w-full"
          >
            <div className="relative">
              <label
                htmlFor="message"
                className="absolute -top-4 z-1 left-10 bg-[#FFF8EC] px-2 text-[20px] text-gray-600"
              >
                Your Message:
              </label>
              <Input.TextArea
                id="message"
                placeholder="Enter your message"
                rows={4}
                className="w-full p-3 bg-[#FFF8EC] border-2 border-black rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </Form.Item>
          <Button
            className="bg-[#F9B138] btn-lg w-full h-[44px] text-[20px] lg:w-auto"
            htmlType="submit"
          >
            Send Message
          </Button>
        </Form>
      </Col>
    </Row>
  </Col>
  <Col xs={24} lg={9} className="p-2">
    <Card className="bg-[#FFF8EC] border-1 mb-3 border-gray-300">
      <Row align="middle" >
        <Col span={24}>
          <p className="text-[20px]">Contact</p>
          <a href={`tel:${mobileNumber ? mobileNumber : ""}`} className="flex space-x-4 items-center text-[#F9B138]">
          <div className="flex space-x-4 items-center text-[#F9B138]">
            <BiPhone className="text-[16px]" />
            <p className="text-[16px]">+91 {mobileNumber ? mobileNumber : ""}</p>
          </div>
          </a>
          <hr className="w-full border-black my-2" />
        </Col>
        <Col span={24}>
          <p className="text-[20px]">Address</p>
          <div className="flex space-x-4 pt-2 items-center text-black">
            <p className="text-[16px]">
              {`${buildingName ? buildingName : ""}, ${streetName ? streetName : ""}, ${city ? city : ""} ${state ? state : ""}, ${pincode ? pincode : ""}`}
            </p>
          </div>
          <div className="flex space-x-4 pt-2 justify-normal items-center text-black">
            <div
              className="text-[#F9B138] flex items-center text-[16px] cursor-pointer"
              onClick={handleCopyToClipboard}
            >
              <BiDirections className="mr-2" /> Get Direction
            </div>
            <div
              className="text-[#F9B138] flex items-center text-[16px] cursor-pointer"
              onClick={handleAddressToClipboard}
            >
              <CopyFilled className="mr-2" /> Copy Address
            </div>
          </div>
          {
            isOwner && (
          <hr className="w-full border-black my-2" /> )}
        </Col>
   
        {
            isOwner && (
            <Col span={24} className="flex space-x-4 items-center pt-1 pb-1 cursor-pointer text-[#F9B138]" onClick={handleEditRedirect}>
                <ClockCircleFilled className="text-[16px]" />
                <p className="text-[16px]">Add Business Hours</p>
            </Col>
            )}
            <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
            <Col span={24} >
            <a  className="flex space-x-4 items-center pt-1 pb-1 text-black" href={`mailto:${email}`}>
                <BsFillPhoneFill  className="text-[16px]" />
                <p className="text-[16px]">SMS / Email</p>
            </a>
            </Col>
            <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
            <Col span={24} onClick={handleCopyToClipboard} className="flex cursor-pointer space-x-4 items-center pt-1 pb-1 text-black">
                <FaShare  className="text-[16px]" />
                <p className="text-[16px]">Share</p>
            </Col>
            <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
            <Col span={24} className="flex space-x-4 cursor-pointer items-center pt-1 pb-1 text-black"
          onClick={() => 
            isLoggedIn ? setIsRatingModalVisible(true) : message.error("Please login to write a review")
           } // Show modal on button click
            >
                <FaStar  className="text-[16px]" />
                <p className="text-[16px]">Tap to rate</p>
            </Col>
          
           {
            isOwner && (
              <>
              <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
              <Col span={24} >
              <Link to={`/business/${businessId}/edit`} >
              <div className="flex space-x-4 items-center pt-1 pb-1 text-black">
                  <FaEdit  className="text-[16px]" />
                  <p className="text-[16px]">Edit this</p>
        </div>
              </Link> 
              </Col>
              <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
              <Link to={`/backend/mywebsite`} >
            <Col span={24} className="flex space-x-4 items-center pt-1 pb-1 text-[#F9B138]">
                <FaEdit  className="text-[16px]" />
                <p className="text-[16px]">Add website</p>
            </Col>
            </Link>
              </>
            )
           }
           
            <Col span={24} className=" pt-2 pb-2"><hr className="w-[100%] border-black" /></Col>
            <Col span={24} className="flex space-x-4 cursor-pointer items-center pt-1 pb-1 text-[#F9B138]"
            onClick={
              () => {
                if (isOwner) {
                  navigate(`/business/${businessId}/edit`);
              }
            }
          }
            >
                <CalculatorOutlined  className="text-[16px]" />
                <p className="text-[16px]"> { gstinNo ? "GSTIN No : " + gstinNo : "GSTIN NO" }</p>
            </Col>
            
      </Row>
    </Card>
  </Col>
</Row>

      </>
      ,
    },
    {
      key: '2',
      label: (
        <div
          className={`text-[22px] ${
            activeKey === "2" ? "text-[#F9B138]" : "text-black"
          }`}
        >
          Photos
        </div>
      ),
      children: 
      <>
 <div className="photo-gallery">
 {galleryImage.map((image, index) => (
  image ? ( // Check if the image exists
    <div key={index} className={`gallery-item item-${index}`}>
      <img 
        src={`${imageUrl}${image}`} 
        alt={`Gallery ${index + 1}`} 
      />
    </div>
  ) : ( // Fallback for missing image
    <div key={index} className={`gallery-item item-${index} placeholder`}>
      <p>Image not available</p>
    </div>
  )
))}

    </div>
      </>
      ,
    },
    {
      key: '3',
      label: <> <div
      className={`text-[22px] ${
        activeKey === "3" ? "text-[#F9B138]" : "text-black"
      }`}
    >
      Timings
    </div></>,
      children: 
      <>
   <div className="timings-container">
  <Row justify="start" className="timings-row">
    {businessHours.map((day, index) => (
      <Col key={day.name}>
        <Button
          className={`${
            day.selected ? "selected-day" : "timiingSlotcheckbox"
          }`}
          style={{ cursor: "default", pointerEvents: "none" }} // Removes pointer interaction and hover
        >
          {day.name}
        </Button>
      </Col>
    ))}
  </Row>
</div>

      
      <h2 className="text-2xl font-semibold mb-6">Connect with Owner</h2>
      <Row className="pt-5" justify="center">
  {/* Quick Call Button */}
  <Col xs={24} sm={8} md={8} lg={8} xl={8} xxl={8} className="p-2 pb-5">
    <a href={`tel:${mobileNumber}`}>
      <button className="relative flex items-center justify-center w-full px-4 py-4 bg-[#F9B138] hover:bg-yellow-600 text-white font-medium rounded-lg shadow-lg text-base transition whitespace-nowrap">
        {/* Enlarged Icon */}
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 h-14 w-14 rounded-full bg-[#FDF0CE] flex items-center justify-center shadow-md">
          <BiPhone className="text-[#FBCA25] text-2xl" />
        </div>
        Make a Quick Call
      </button>
    </a>
  </Col>
  {/* Chat with Owner Button */}
  <Col xs={24} sm={10} md={10} lg={10} xl={10} xxl={10} className="p-2">
    <a href={`https://wa.me/${mobileNumber}`}>
      <button className="relative flex items-center justify-center w-full px-4 py-4 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg shadow-lg text-base transition whitespace-nowrap">
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 h-14 w-14 rounded-full bg-[#FDF0CE] flex items-center justify-center shadow-md">
          <FaWhatsapp className="text-[#1DDB00] text-2xl" />
        </div>
        Chat with the Owner
      </button>
    </a>
  </Col>
</Row>
    
        </>
      ,
    },
    {
      key: '4',
      label: <> <div
      className={`text-[22px] ${
        activeKey === "4" ? "text-[#F9B138]" : "text-black"
      }`}
    >
      Reviews
    </div></>,
      children: 
      <>
        <div className="p-4 flex flex-col sm:flex-row justify-between items-center pb-2">
          <p className="text-[22px]"> Reviews & Ratings - {businessName} </p>
  {/* Add Review Button */}
  {isLoggedIn && (
        <Button
          type="primary"
          onClick={() => setIsRatingModalVisible(true)} // Show modal on button click
          className="bg-yellow-500 text-white"
        >
          Add Review
        </Button>
      )}
</div>
      {renderReviews(reviews)}
      </>
      ,
    }
  ];
  



  return (
    <div className="bg-[#FFF8EC] min-h-screen xl:pt-32 pt-24 lg:pl-24 lg:pr-24">
      <Modal
      visible={isRatingModalVisible}
      onCancel={() => setIsRatingModalVisible(false)}
      footer={null}
      centered
      title=""
    >
   <div
  style={{
    maxWidth: '500px',
    margin: '0 auto',
    padding: '20px',
    background: '#ffffff',
    borderRadius: '8px',
  }}
>
  <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#333' }}>
    Rate Your Experience
  </h3>
  <div className="flex items-center mb-3">
  <label
    style={{
      fontSize: '16px',
      fontWeight: '600',
      color: '#555',
      display: 'block',
      marginRight: '8px',
    }}
  >
    Rating:
  </label>
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '8px',
      
    }}
  >
   <div className="text-yellow-400  text-3xl">
  {Array.from({ length: 5 }, (_, index) => (
    <span
      key={index}
      onClick={() => handleRatingClick(index)} // Pass index directly
      style={{ cursor: 'pointer' }}
    >
      {index < rating ? '★' : '☆'}
    </span>
  ))}
</div>

  </div>
  </div>
 
  
  
  
  <Input.TextArea
    value={reviewText}
    onChange={(e) => setReviewText(e.target.value)}
    placeholder="Write your review here..."
    rows={4}
    style={{
      marginBottom: '16px',
      borderRadius: '8px',
      borderColor: '#d9d9d9',
      fontSize: '14px',
    }}
  />
  
  <Button
          type="primary"
          onClick={handleSubmit}
          loading={isRatingLoading} // Attach loading state
          style={{
            width: "100%",
            padding: "12px 0",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "8px",
            backgroundColor: "#1890ff",
          }}
        >
          Submit Review
        </Button>
</div>

    </Modal>

            <Row className="">
              <Col
                xs={24}
                sm={24}
                md={8}
                lg={5}
                xl={5}
                className="cursor-pointer border-l border-t border-b !border-r-0"

              >
                <Carousel
                  dots={false}
                  arrows
                  autoplay
                  autoplaySpeed={3000}
                  // nextArrow={<NextArrow />}
                  // prevArrow={<PrevArrow />}
                  draggable
                  // beforeChange={(from, to) => {
                  //   if (from === 1 && to === 2) {
                  //     setShowRightArrow(true);
                  //   }
                  // }}
                >
                  {galleryImage.map((image: any, imgIndex: any) => (
                    <img
                      key={imgIndex}
                      className=" h-60 xl:h-60 md:h-60 p-4 bg-[#FFF8EC]  w-full lg:h-48 rounded-xl"
                      src={`${imageUrl}${image}`}
                      alt={`Carousel ${imgIndex}`}
                    />
                  ))}
                </Carousel>
                {/* <div className="flex  items-center pt-2">
                  <div className="m-2 ">
                    <button className="rounded-xl px-4 py-2 bg-[#F7D278]">
                      Upgrade Plan
                    </button>
                  </div>
                  <div className="m-2">
                    <button className="rounded-xl px-6 py-2 shadow-md bg-[#FFF2D3]">
                      Edit Business Profile
                    </button>
                  </div>
                </div> */}
              </Col>
              <Col
                xs={24}
                sm={18}
                md={16}
                lg={19}
                xl={19}
                xxl={19}
                className="p-4 border-l-0 border-t border-b border-r"
                
              >
                <div className="flex justify-between items-center md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                  <div className="flex items-center">
                    <p
                      className="text-black pl-2 text-2xl xl:text-2xl hover:text-yellow-500 font-semibold cursor-pointer"
                      onClick={() => navigate(`/business/${slug}`)}
                    >
                      {businessName}
                    </p>
                  </div>
                  <div></div>
                </div>
                <div className="flex flex-wrap items-center pt-2">
                  <span className="text-sm rounded-md px-3 py-1 flex items-center justify-between tracking-widest bg-green-700 text-yellow-100">
                    <span>
                      <FaStar className="text-yellow-400" />
                    </span>
                    <span className="">&nbsp;{averageRating ? averageRating?.toFixed(1) : 0}</span>
                  </span>
                  <div className="flex pl-2">
                  {reviews.length} Ratings
                  </div>
                 
                  <p className="pl-2 flex">
                  {isVerified === 2 && (
                    <div className="flex businesss-center space-x-1 pt-2">
                      <img src={verifiedlogo} alt="logo" className="w-8 h-8" />
                    </div>
                   )}
                    {isTrusted === 2 && ( 
                    <div className="flex items-center space-x-1 pt-2">
                      <img src={trustLogo} alt="logo" className="w-8 h-8" />
                    
                    </div>
                    )}
                  </p>
                  <p className="pl-2">
                  {/* <p>{calculateBusinessAge(createdAt)} </p> */}
                  </p>
                </div>
                <p className="text-black pl-2 text-md pt-3 font-bold">
                  Address
                </p>
                <div className="flex items-center pt-2">
                  <EnvironmentOutlined
                    size={20}
                    className="pr-2 text-yellow-500 font-semibold"
                  />
                  <p>{`${buildingName}, ${streetName} ,${city} , ${state} , , ${pincode}`}</p>
                </div>
                <div className="flex items-center pt-3">
                  {/* <Badge className="text-sm rounded-md pl-1 pr-1 px-2 py-1 bg-slate-200 text-gray-800">
                      {categoryId[0].name
                        ? categoryId[0].name
                        : "Category"}
                    </Badge> */}
                </div>
                <Row >
                             <Col
                               xs={12}
                               sm={8}
                               md={5}
                               lg={5}
                               xl={3}
                               xxl={3}
                               className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-auto"
                             >
                              <a href={`tel:${mobileNumber}`} target="_blank" rel="noopener noreferrer">
                               <button
                                 className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#118601] border-2 border-[#118601] text-white w-full text-md sm:text-md"
                               // onClick={() => handleToggleNumberVisibility(business.slug)}
                               >
                                 <BiPhoneCall />
                                 <span>call</span>
                               </button>
                               </a>
                             </Col>
                        
                             <Col
                               xs={12}
                               sm={8}
                               md={7}
                               lg={5}
                               xl={3}
                               xxl={3}
                               className=" mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 md:ml-1 md:mr-1 w-auto"
                             >
                               <Link to={`https://wa.me/${whatsappNumber}?text=I'm interested in ${businessName}`} target="_blank" rel="noopener noreferrer">
                                 
                               <button
                                 className="flex items-center justify-center space-x-1 px-1 py-1.5 rounded-md  border-1 border-gray-900 text-gray-700 w-full text-md sm:text-md"
                               >
                                 <FaWhatsapp color="green" fill="green" />
                                 <span>Chat</span>
                               </button>
                               </Link>
                             </Col>
                             <Col
                               xs={24}
                               sm={8}
                               md={11}
                               lg={5}
                               xl={4}
                               xxl={4}
                               className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                             >

                               <button
                                 className="flex items-center justify-center space-x-2 px-2 py-1.5 rounded-md  border-1 border-gray-900 text-black w-full text-md sm:text-md whitespace-nowrap"
                                 onClick={() => 
                                  isLoggedIn ? setIsRatingModalVisible(true) : handleLogin()
                                 } // Show modal on button click
                               >
                                 <FaStar className="text-yellow" />
                                 <span className="truncate ">Write Review</span>
                               </button>
                             </Col>
                           </Row>
              </Col>
      
                    <Col span={24} className="pt-4">
                    <Tabs
    defaultActiveKey="1"
    activeKey={activeKey}
    onChange={handleTabChange}
    items={items}
    tabBarStyle={{ border: "none" }}
    className="custom-tabs"
  />

                      </Col>
            </Row>

          
 


         
    </div>
  );
};

export default BusinessDetail;
